
import {Component, Vue} from 'vue-property-decorator'
import ContactTable from './components/contactTable.vue'
import {ContactService} from '@/services/index'
import {AppModule} from '@/store/modules/app'
import {convertCodeToText} from '@/common/area_data'
import {iFile, parseTime} from '@/common/utils'

@Component({
    name: 'AuditContacts',
    components: {
        ContactTable
    }
})
export default class extends Vue {
    // 新增：高级筛选展开状态
    private isAdvancedFilterOpen = false

    // 原有数据完全保留
    private contacts = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private loading = true
    private exportLoading = false
    private curStatus = ''
    private curType = ''
    private curClaimStatus = ''
    private paid = ''
    private titleQuery = ''
    private detailQuery = ''
    private curRegion = ''
    private startTime: any = ''
    private endTime: any = ''
    private isReported: any = 0
    private payOptions = [
        {key: '', value: '所有报料'},
        {key: 0, value: '普通报料'},
        {key: 1, value: '付费报料'}
    ]
    private statusOptions = [
        {key: '', value: '所有状态'},
        {key: 1, value: '未跟进'},
        {key: 2, value: '跟进中'},
        {key: 3, value: '跟进完成'},
        {key: 4, value: '无需跟进'}
    ]
    private typeOptions = [
        {key: '', value: '所有事由'},
        {key: 1, value: '报料'},
        {key: 2, value: '邀请'},
        {key: 3, value: '反馈问题'}
    ]
    private claimStatusOptions = [
        {key: '', value: '所有记者'},
        {key: 1, value: '已认领'},
        {key: 0, value: '未认领'}
    ]
    private reportedOption = [
        {key: '', value: '所有报道'},
        {key: 0, value: '未报道'},
        {key: 1, value: '已报道'}
    ]

    get provinceAndCityData() {
        return AppModule.provinceAndCity
    }

    private mounted() {
        this.getContacts()
        AppModule.getRegion()
    }

    // 原有方法完全保留
    private async getContacts() {
        const [province, city] = convertCodeToText(this.curRegion).split(',')
        const params: any = {
            title: this.titleQuery,
            detail: this.detailQuery,
            status: this.curStatus,
            type: this.curType,
            certStatus: this.curClaimStatus,
            paid: this.paid,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            startTime: this.startTime,
            endTime: this.endTime,
            isReport: this.isReported
        }
        // 只有选择了具体地区才传递province和city参数（排除"全国"）
        if (province && province !== '全国') {
            params.province = province
        }
        if (city && city !== '全国') {
            params.city = city
        }
        this.loading = true
        const result = await ContactService.getContacts(params)
        this.loading = false
        if (result.status === 200) {
            this.contacts = result.data.contacts
            this.pageTotal = result.data.page_total
        }
    }

    private onOptionSelect() {
        this.pageIndex = 1
        this.getContacts()
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getContacts()
        $backtop.scrollToTop()
    }

    private onSelectRegionChange() {
        if (!this.curRegion.length) {
            this.getContacts()
        }
    }

    private onSelectRegionResult(status: boolean) {
        if (status) return
        if (this.curRegion.length) {
            this.getContacts()
        }
    }

    // 原有全局重置功能不变
    private onReset() {
        this.titleQuery = ''
        this.detailQuery = ''
        this.startTime = ''
        this.endTime = ''
        this.paid = ''
        this.curStatus = ''
        this.curType = ''
        this.curClaimStatus = ''
        this.curRegion = ''
        this.isReported = 0
        this.getContacts()
    }

    // 新增：仅重置高级筛选条件
    private resetAdvancedFilter() {
        this.curType = ''
        this.curClaimStatus = ''
        this.paid = ''
        this.curRegion = ''
        this.isReported = 0
        this.getContacts()
    }

    private async onExport() {
        this.$confirm('即将开始下载Excel文件', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                await this.exportContact()
            })
            .catch(err => {
                this.$message.error(err.message)
            })
    }

    private async exportContact() {
        const [province, city] = convertCodeToText(this.curRegion).split(',')
        const params: any = {
            title: this.titleQuery,
            detail: this.detailQuery,
            status: this.curStatus,
            type: this.curType,
            cert_status: this.curClaimStatus,
            paid: this.paid,
            page_index: this.pageIndex,
            page_size: this.pageSize,
            created_at_gte: this.startTime,
            created_at_lte: this.endTime,
            is_report: this.isReported
        }
        // 只有选择了具体地区才传递province和city参数（排除"全国"）
        if (province && province !== '全国') {
            params.province = province
        }
        if (city && city !== '全国') {
            params.city = city
        }
        try {
            this.exportLoading = true
            const result = await ContactService.exportContacts(params)
            if (result.status === 200) {
                const {file_name: fileName, file_data: fileData} = result.data
                if (!fileData) return this.$merror('暂无数据')
                return iFile.downloadBase64File(fileData, fileName)
            }
            this.$merror('发生错误, 请稍后再试')
        } finally {
            this.exportLoading = false
        }

    }

    private onTimeChange() {
        this.getContacts()
    }
}
